import { React, useState } from 'react';
import { SwatchesPicker } from 'react-color';
import Modal from '../Modal';
import './index.scss';

const ColorPicker = ({ color, show, setShow, onChange }) => {
  const [selectedColor, setSelectedColor] = useState(color);

  if (!show) {
    return null;
  }

  const onChangeColorPicker = (color) => {
    setSelectedColor(color);
  };

  const onClick = (event) => {
    event.preventDefault();

    onChange(selectedColor);
    setShow(false);
  };

  const onClickClose = (event) => {
    event.preventDefault();

    setShow(false);
  };

  return (
    <Modal title='Selecciona un color' fast={true}>
      <SwatchesPicker color={selectedColor} onChange={onChangeColorPicker} />
      <button className='button button--tool' onClick={onClick}>
        Escoger
      </button>
      <button className='button button--tool' onClick={onClickClose}>
        Cancelar
      </button>
    </Modal>
  );
};

export default ColorPicker;
